var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea textarea--basic-standard"},[_vm._t("label",function(){return [(_vm.label)?_c('label',{staticClass:"textarea__label",class:{ 'visually-hidden': _vm.labelHidden },attrs:{"for":_vm.id}},[_vm._v("\n\t\t\t"+_vm._s(_vm.label)+"\n\t\t")]):_vm._e()]},{"id":_vm.id,"label":_vm.label,"labelHidden":_vm.labelHidden}),_vm._v(" "),_c('textarea',_vm._g(_vm._b({staticClass:"textarea__input textarea__input--basic-standard",class:[
			_vm.customInputClasses,
			{
				'-disabled': _vm.isDisabled,
				'-error': _vm.error
			}
		],style:(_vm.style),attrs:{"id":_vm.id,"disabled":_vm.isDisabled},domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),{
			..._vm.$listeners,
			input: (e) => _vm.$emit('input', e.target.value)
		})),_vm._v(" "),_c('div',{staticClass:"validation-container",style:(`min-height: ${_vm.validationFixedHeight}`)},[_c('ValidationErrors',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],staticClass:"textarea__validation_errors",attrs:{"errors":_vm.errorMessages}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }